import { render, staticRenderFns } from "./layersTable.vue?vue&type=template&id=194f52d4"
import script from "./layersTable.vue?vue&type=script&lang=js"
export * from "./layersTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports